import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api';

const AuthCtx = createContext({ user: null, login: () => {}, logout: () => {}, loading: true });

export const LiqAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem('liq_token');
    const u = localStorage.getItem('liq_user');
    if (t && u) {
      try { setUser(JSON.parse(u)); } catch { /* noop */ }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const r = await api.post('/auth/login', { email, password });
    localStorage.setItem('liq_token', r.data.token);
    localStorage.setItem('liq_user', JSON.stringify(r.data.employee));
    setUser(r.data.employee);
    return r.data.employee;
  };

  // Adopt an externally-issued token+employee (Google OAuth / OTP verify).
  const adopt = (token, employee) => {
    localStorage.setItem('liq_token', token);
    localStorage.setItem('liq_user', JSON.stringify(employee));
    setUser(employee);
  };

  const logout = () => {
    localStorage.removeItem('liq_token');
    localStorage.removeItem('liq_user');
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, login, adopt, logout, loading }}>{children}</AuthCtx.Provider>;
};

export const useLiqAuth = () => useContext(AuthCtx);
